export default __webpack_public_path__ + "static/media/p1.8a7a1775.jpg";